module.exports = "/images/departure-icon.svg?9796b6ff7a502e637c2b8ce5e2e08161";